import { render, staticRenderFns } from "./VideoGiftPlayer.vue?vue&type=template&id=4c5e4f2a&"
import script from "./VideoGiftPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoGiftPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports